import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { ArrowRight, Book } from 'react-bootstrap-icons';

const CardComponent = ({ card, buttonColor, handleShowOffcanvas }) => (
  <Card
    className="resource-card h-100"
    style={{
      border: '1px solid var(--border-color)',
      borderRadius: 'var(--border-radius-xl)',
      background: 'var(--bg-primary)',
      transition: 'var(--transition)',
      position: 'relative',
      overflow: 'hidden'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-8px)';
      e.currentTarget.style.boxShadow = 'var(--shadow-xl)';
      e.currentTarget.style.borderColor = 'var(--accent-color)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = 'var(--shadow-md)';
      e.currentTarget.style.borderColor = 'var(--border-color)';
    }}
  >
    <Card.Body className="d-flex flex-column">
      <div className="resource-card-header">
        <div className="resource-icon">
          <Book className="resource-icon-svg" />
        </div>
        <Card.Title className="resource-title">{card.chapterTitle}</Card.Title>
      </div>
      
      <div className="resource-card-content flex-grow-1">
        <p className="resource-description">
          Access comprehensive study materials, notes, and resources for this chapter.
        </p>
      </div>
      
      <div className="resource-card-footer">
        <Button
          onClick={() => handleShowOffcanvas(card)}
          className="resource-btn"
          style={{
            backgroundColor: buttonColor || 'var(--accent-color)',
            border: 'none',
            color: 'white',
            padding: 'var(--spacing-sm) var(--spacing-lg)',
            borderRadius: 'var(--border-radius)',
            fontWeight: '600',
            width: '100%',
            transition: 'var(--transition)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--accent-light)';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = buttonColor || 'var(--accent-color)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          View Resources
          <ArrowRight className="ms-2" />
        </Button>
      </div>
    </Card.Body>
  </Card>
);

export default CardComponent;
